/**
 * Navigation
 * Author: Kyle Shearer
 */

var Navigation = (function () {

    var options = {
        navicon: $('.js-navicon'),
        mobileNavigation: $('.js-mobile-navigation')
    };

    function canInit() {

        if (options.navicon.length) {
            return true;
        }

        return false;
    }

    function init(params) {
        options = $.extend({}, options, params);

        if (canInit()) {
            
            options.navicon.on('click', function(e){
                e.preventDefault();

                $(this).toggleClass('is-active');
                $('body').toggleClass('navigation-is-active');
                
                options.mobileNavigation.fadeToggle().toggleClass('is-active')
            });
        }

        console.log('Navigation initialized');
    }

    return {
        init: init
    };
    
})();

$(function () {
    'use strict';
    Navigation.init();
});